exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableTitle[data-v-971db6ca]{font-size:16px;font-family:Microsoft YaHei;font-weight:400;color:#333333;text-align:center;line-height:35px}[data-v-971db6ca] .el-dialog__body{padding:20px 80px}\n", ""]);

// exports
